import { SxProps } from "@mui/material";

const TableContainerSXProps: SxProps = {
  width: { lg: "1254px", md: "100%", sm: "100%" },
  minWidth: 1100,
  m: "8px auto",
  borderCollapse: "collapse",
  overflow: "auto",
  fontSize: { xs: 16, md: 18, lg: 20 },
  "& .MuiTableCell-head": {
    border: "1px solid white",
    fontWeight: "bold",
  },
};

const TableRowSxProps: SxProps = {
  fontWeight: "bold",
  fontSize: { xs: 16, md: 18, lg: 20 },
  bgcolor: "var(--primary-500)",
  minWidth: "40px",
  "& .MuiTableCell-head": {
    minWidth: "40px",
  },
};

const TableButtonSxProps: SxProps = {
  width: "80%",
  minWidth: "80px",
  boxShadow: "0 2px 6px var(--shadow-sm-overlay)",
  fontWeight: "regular",
  bgcolor: "var(--white)",
  border: "1px solid var(--gray-250)",
  backgroundColor: "var(--white)",
  color: "var(--black)",
  fontSize: { xs: 16, md: 18, lg: 20 },
  borderRadius: "4px",
  height: "40px",
  whiteSpace: "pre",
};

export { TableContainerSXProps, TableRowSxProps, TableButtonSxProps };
